<template>
  <div class="row px-4">
    <div class="col-12">
      <p class="text-center">{{ $t('schedule_prompt') }} *</p>
    </div>
    <div class="col-12">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">8-11 am</th>
            <th scope="col">11-3 pm</th>
            <th scope="col">3-6 pm</th>
            <th scope="col">{{ $t('not_available') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="day in days" :key="day">
            <th scope="row">{{ $t('days.' + day.toLowerCase()) }}</th>
            <td v-for="hour in hours" :key="hour">
              <b-form-checkbox size="lg" :disabled="readonly" :value="hour" :checked="Object.keys(applicationData[day.toLowerCase()])" @change="updateAvailability(day, hour, $event)"></b-form-checkbox>
            </td>
          </tr>
        </tbody>
      </table>
      <more-info />
    </div>
  </div>
</template>
<script>
import '@/shared/validations.js'
import Vue from 'vue'
import MoreInfo from './more_info.vue'
import {
  Days
} from '@/utils.js'

export default {
  components: {
    MoreInfo
  },
  props: {
    readonly: {
      type: Boolean,
      required: true
    },
    applicationData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      availability: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: []
      }
    }
  },
  computed: {
    days() {
      return Days
    },
    hours() {
      return [8, 11, 15, 0]
    }
  },
  methods: {
    updateAvailability(day, hour, status) {
      this.$emit('update', {
        availability: {
          day: day.toLowerCase(),
          hour: hour,
          status: status !== false
        }
      })
    },
    removeUnavailability(day, status) {
      if (status !== false) {
        this.applicationData[day.toLowerCase()] = []
      }
    }
  },
  watches: {
    applicationData: {
      deep: true,
      handler(newValue, oldValue) {
        console.log("app change", oldValue, newValue)
      }
    }
  }
}
</script>
